module.exports = __webpack_public_path__ + "img/i-email.e8bfe35b.png";